import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDuplicate = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_397_32364",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 20,
		height: 20,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_397_32364)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M6.82704 17.9166C6.4062 17.9166 6.04995 17.7708 5.75829 17.4791C5.46662 17.1874 5.32079 16.8311 5.32079 16.4101V14.6793H3.58995C3.16898 14.6793 2.81266 14.5335 2.521 14.2418C2.22933 13.9501 2.0835 13.5939 2.0835 13.173V11.6345H3.3335V13.173C3.3335 13.2478 3.35752 13.3092 3.40558 13.3572C3.45364 13.4054 3.51509 13.4295 3.58995 13.4295H5.32079V6.82679C5.32079 6.40596 5.46662 6.04971 5.75829 5.75804C6.04995 5.46638 6.4062 5.32054 6.82704 5.32054H13.4297V3.58971C13.4297 3.51485 13.4056 3.45339 13.3575 3.40534C13.3094 3.35728 13.248 3.33325 13.1733 3.33325H11.6347V2.08325H13.1733C13.5941 2.08325 13.9504 2.22909 14.242 2.52075C14.5337 2.81242 14.6795 3.16874 14.6795 3.58971V5.32054H16.4104C16.8313 5.32054 17.1877 5.46638 17.4793 5.75804C17.771 6.04971 17.9168 6.40596 17.9168 6.82679V16.4101C17.9168 16.8311 17.771 17.1874 17.4793 17.4791C17.1877 17.7708 16.8313 17.9166 16.4104 17.9166H6.82704ZM6.82704 16.6666H16.4104C16.4745 16.6666 16.5333 16.6398 16.5866 16.5864C16.6401 16.533 16.6668 16.4743 16.6668 16.4101V6.82679C16.6668 6.76277 16.6401 6.70402 16.5866 6.65054C16.5333 6.59707 16.4745 6.57034 16.4104 6.57034H6.82704C6.76301 6.57034 6.70426 6.59707 6.65079 6.65054C6.59732 6.70402 6.57058 6.76277 6.57058 6.82679V16.4101C6.57058 16.4743 6.59732 16.533 6.65079 16.5864C6.70426 16.6398 6.76301 16.6666 6.82704 16.6666ZM2.0835 9.80763V6.95513H3.3335V9.80763H2.0835ZM2.0835 5.12804V3.58971C2.0835 3.16874 2.22933 2.81242 2.521 2.52075C2.81266 2.22909 3.16898 2.08325 3.58995 2.08325H5.12829V3.33325H3.58995C3.51509 3.33325 3.45364 3.35728 3.40558 3.40534C3.35752 3.45339 3.3335 3.51485 3.3335 3.58971V5.12804H2.0835ZM6.95537 3.33325V2.08325H9.80787V3.33325H6.95537Z",
			fill: "currentColor"
		})
	})]
});
export default SvgDuplicate;
